<script setup lang="ts">
import ExtensionGridTitle from "@/extension/components/extension-grid/ExtensionGridTitle.vue";
import {Skeleton} from "@/core/components/ui/skeleton";

const {count = 3} = defineProps<{
    count?: number;
    title?: string;
    logo?: boolean;
}>();
</script>

<template>
  <div class="flex flex-col gap-3">
    <div class="flex items-baseline">
      <Skeleton v-if="logo" class="w-8 h-8 mr-2" />
      <ExtensionGridTitle v-if="title" :title="title" />
      <Skeleton v-else class="w-32 h-4" />
    </div>
    <div class="flex flex-row justify-start items-start flex-wrap gap-x-6 gap-y-6">
      <div v-for="(_, index) in count" :key="index">
        <Skeleton class="h-28 w-28" />
        <Skeleton class="h-3 w-2/3 mt-1" />
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
